import React, { useRef, useContext } from "react";
import Carousel, { consts } from "react-elastic-carousel";
import { isMobile } from "react-device-detect";
import { GlobalContext } from "GlobalContext";
import MemberCard from "./MemberCard";
import {
  TeamCarouselWrapper,
  CarouselArrow,
} from "./styles/TeamCarouselStyles";

const TeamCarousel = ({ members }) => {
  const { currentLang } = useContext(GlobalContext);
  const isEn = currentLang === "en";
  const carouselRef = useRef();

  // Wrap around at both ends.
  const onNextStart = (currentItem, nextItem) => {
    if (currentItem.index === nextItem.index) {
      carouselRef.current.goTo(0);
    }
  };
  const onPrevStart = (currentItem, nextItem) => {
    if (currentItem.index === nextItem.index) {
      carouselRef.current.goTo(members.length);
    }
  };

  return (
    <TeamCarouselWrapper className="team-carousel">
      <Carousel
        infinite
        ref={carouselRef}
        onPrevStart={onPrevStart}
        onNextStart={onNextStart}
        itemsToShow={isMobile ? 1 : 4}
        itemPadding={[0, 12]}
        pagination={false}
        enableAutoPlay
        autoPlaySpeed={5000}
        renderArrow={({ type, onClick }) => {
          const prev = type === consts.PREV;
          return (
            <CarouselArrow
              type="button"
              onClick={onClick}
              aria-label={
                prev ? (isEn ? "Previous" : "Précédent") : isEn ? "Next" : "Suivant"
              }
            >
              <svg viewBox="0 0 24 24" aria-hidden="true">
                <path d={prev ? "M15 5l-7 7 7 7" : "M9 5l7 7-7 7"} />
              </svg>
            </CarouselArrow>
          );
        }}
      >
        {members &&
          members.map((member, i) => <MemberCard key={i} data={member} />)}
      </Carousel>
    </TeamCarouselWrapper>
  );
};

export default TeamCarousel;
